import { defineStore } from 'pinia'
import { getGitHubUserInfo } from '@/services/authService'

// Token 有效期（分钟），与后端配置保持一致
const TOKEN_EXPIRE_MINUTES = 15
// 提前刷新的时间（分钟）
const REFRESH_BUFFER_MINUTES = 5

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    tokenTimestamp: parseInt(localStorage.getItem('tokenTimestamp') || '0', 10),
    userInfo: null
  }),

  getters: {
    isLoggedIn: state => !!state.token,
    isAdmin: state => state.userInfo?.role === 2,
    // 计算 token 是否即将过期（剩余时间小于 REFRESH_BUFFER_MINUTES）
    isTokenExpiringSoon: state => {
      if (!state.token || !state.tokenTimestamp) return false
      const now = Date.now()
      const expireAt = state.tokenTimestamp + TOKEN_EXPIRE_MINUTES * 60 * 1000
      const remainMs = expireAt - now
      return remainMs > 0 && remainMs < REFRESH_BUFFER_MINUTES * 60 * 1000
    },
    // 计算距离过期的毫秒数
    tokenRemainingMs: state => {
      if (!state.token || !state.tokenTimestamp) return 0
      const expireAt = state.tokenTimestamp + TOKEN_EXPIRE_MINUTES * 60 * 1000
      return Math.max(0, expireAt - Date.now())
    }
  },

  actions: {
    setToken(token) {
      this.token = token
      this.tokenTimestamp = Date.now()
      localStorage.setItem('token', token)
      localStorage.setItem('tokenTimestamp', this.tokenTimestamp.toString())
    },

    setUserInfo(info) {
      this.userInfo = info
      if (info?.role != null) {
        localStorage.setItem('userRole', info.role.toString())
      }
    },

    async fetchUserInfo() {
      if (!this.token) return
      try {
        const res = await getGitHubUserInfo()
        if (res.code === 200) {
          this.setUserInfo(res.data)
        }
      } catch {
        this.logout()
      }
    },

    logout() {
      this.token = null
      this.tokenTimestamp = 0
      this.userInfo = null
      localStorage.removeItem('token')
      localStorage.removeItem('tokenTimestamp')
      localStorage.removeItem('userRole')
      localStorage.removeItem('github_code')
    },

    handleGitHubCallback() {
      const urlParams = new URLSearchParams(window.location.search)
      const code = urlParams.get('code')
      if (code) {
        localStorage.setItem('github_code', code)
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    }
  }
})
